export const OPTHINES = {
  voteName: '2020project/2020ordinaryhero',
  mustSearch: 'Button',
  buttonBg: '#FAC958',
  number: {
    mustRank: false,
  },
  title: true,
  subtitle: true,
  user: true,
  checkBox: false,
  tickets: {
    textFirst: '力量值',
  },
  hasVoteButton: {
    text: '加油',
    themeColor: '#CC1F20',
    textColor: '#fff',
  },
  themeColor: {
    activeBgColor: '#F9C758',
    inactiveBgColor: '#D82927',
  },
  tabs: [
    {
      tabName: '活动主页',
      tabPath: '/20200211ZMXL/List',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200211ZMXL/Rules',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200211ZMXL/News',
    },
  ],
};
